import React, { useState } from "react";
import PropTypes from "prop-types";
import { PanelWrapper } from "./styles";

const Panel = ({ header, content }) => {
	const [isActive, setIsActive] = useState(false);

	const iconName = isActive ? "minus" : "plus";
	const stopPropagation = (event) => event.stopPropagation();

	const formattedContent = content.replace(
		/<a href=/gi,
		"<a target='_blank' href=",
	);

	return (
		<PanelWrapper isActive={isActive}>
			<div className="header" onClick={() => setIsActive(!isActive)}>
				<div>
					<img
						src={`https://res.cloudinary.com/springboard-images/image/upload/c_limit,dpr_1.0,f_auto,fl_lossy,q_auto,w_16/v1/homepage-assets/icons/${iconName}.png`}
						className="icon"
					/>
				</div>
				<span className="headerText">{header}</span>
			</div>
			<div
				className="detail"
				onClick={stopPropagation}
				dangerouslySetInnerHTML={{ __html: formattedContent }}
			></div>
		</PanelWrapper>
	);
};

Panel.propTypes = {
	header: PropTypes.string,
	content: PropTypes.string,
};

Panel.defaultProps = {
	header: "",
	content: "",
};

export default Panel;
